export const SUPER_SYMBOL = "super";
